import React, { useState, useEffect } from "react";
import Header from "../Header/AppHeader";
import Footer from "../Footer/AppFooter";
import { callCommonAction } from "../../redux/Common/CommonReducer";
import { sendRequest } from "../../apis/APIs";
import { handleApiResponse } from "../../apis/apiUtils";
import moment from "moment";
import Pagination from "../../common/Pagination/pagination";
import appSettings from "../../configs/AppConfig";
import { useNavigate, useLocation } from 'react-router-dom';
import Alert from "../../common/Alerts/Alerts";
import { useDispatch, useSelector } from "react-redux";
import appRoutes from "../../configs/AppRoutes";
import Helper from "../../apis/Helper";
import SendPdfToEmail from "./SendPdfToEmailListPage"
import ProposalInfo from "../Proposal/ProposalInfo"
import { Spinner } from "react-bootstrap";


const ListProposal = () => {
  const [proposalList, setProposalList] = useState([]);
  const [paginationData, setPaginationData] = useState({ perpage: appSettings.recordsPerPageTable, page: 1, totalCount: 0 });
  const [activeTab, setActiveTab] = useState("myProposals");
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const [showModal, setShowModal] = useState(false)
  const [selectedProposal, setSelectedProposal] = useState(null);
  const [users, setUsers] = useState([])
  const [proposalInfoModal, setShowProposalInfoModal] = useState(false)

  const [filter, setFilter] = useState({
    search: searchParams.get("search") || "",
    status: searchParams.get("status") || "",
    order_by: searchParams.get("order_by") || ""
  });
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { user, alert, loading } = useSelector((state) => state.common);

  useEffect(() => {
    getProposalList(1, filter.search, filter.status, filter.order_by);
  }, [filter.order_by, filter.status]);


  const getStatusClass = (status) => {
    const statusClasses = {
      "0": "pending",
      "1": "approved",
      "2": "rejected",
      "3": "draft"
    };
    return statusClasses[status] || "unknown";
  };

  const getStatusText = (status) => {
    const statusText = {
      "0": "Pending",
      "1": "Approved",
      "2": "Rejected",
      "3": "Draft"
    };
    return statusText[status] || "Unknown";
  };

  const getProposalList = async (page = 1, search = "", status = "") => {
    try {
      dispatch(callCommonAction({ loading: true }));
      const res = await sendRequest(`/user/user-documents`, 'GET', {
        page, limit: paginationData.perpage, search, status, order_by: filter?.order_by
      });
      dispatch(callCommonAction({ loading: false }));

      if (res.data.type === "success") {


        // Clean URL parameters - only keep non-empty values
        const currentParams = new URLSearchParams(window.location.search);

        // Update or remove each parameter
        ['status', 'order_by', 'search'].forEach(param => {
          const value = filter[param];
          if (value) {
            currentParams.set(param, value);
          } else {
            currentParams.delete(param);
          }
        });

        // Build the new URL
        const newQueryString = currentParams.toString();
        const newUrl = newQueryString
          ? `${window.location.pathname}?${newQueryString}`
          : window.location.pathname;

        // Update URL without page reload
        window.history.replaceState(null, null, newUrl);

        // Update state
        setProposalList(res.data.data);
        setUsers(res?.data?.users) // Set proposal if needed

        setPaginationData({
          ...paginationData,
          totalCount: res.data.pagination.total,
          page
        });
      }
    } catch (error) {
      dispatch(callCommonAction({ loading: false }));
    }
  };

  const filterProposals = () => {
    if (activeTab === "myProposals") {
      return proposalList.filter((proposal) => proposal?.created_by === user?.id);
    } else if (activeTab === "drafts") {
      return proposalList.filter((proposal) => proposal.status === '3');
    }
    return proposalList;
  };

  const handleProposalInfo = () => {
    setShowProposalInfoModal(true); // Change active tab on click
  };

  const confirmBeforeDelete = (docId) => {
    const custom = Alert.confirmDelete(docId, handleDeleteDocument, () => dispatch(callCommonAction({ alert: null })));
    dispatch(callCommonAction({ alert: custom }));
  };

  const handleDeleteDocument = async (docId) => {
    dispatch(callCommonAction({ alert: null }));

    if (docId) {
      try {
        dispatch(callCommonAction({ loading: true }));
        const res = await sendRequest(`/user/document/${docId}`, "DELETE");
        dispatch(callCommonAction({ loading: false }));
        if (res.data.type === "success") {
          getProposalList(1, filter.search, filter.status, filter.order_by);
        }
      } catch (error) {
        dispatch(callCommonAction({ loading: false }));
      }
    }
  };

  const applyFilter = () => {
    getProposalList(1, filter.search, filter.status, filter.order_by);
  };

  const clearFilter = () => {
    setFilter({ ...filter, search: "", order_by: "", status: "" });
    getProposalList(1, "", filter.status, filter.order_by);
  };

  const handleEditProposal = (proposal) => {

        console.log(proposal,"proposalxxxxxxxxxxxx")
    navigate(`${appRoutes.pdfEditorUpdatePageRoute}/${proposal.id}`, { state: { proposal } });
  };



  const handleButtonClick = (proposal) => {
    setSelectedProposal(proposal); // Store the clicked proposa
    setShowModal(true) // Show the modal when the button is clicked
  }


  const renderProposalCards = () => {
    const filteredProposals = filterProposals();

    if (loading) {
      return (
        <div className="text-center py-5 w-100">
          <div>
            <Spinner animation="border" role="status" variant="warning">
            </Spinner>
          </div>
          <span className="text-muted">Loading documents...</span>
        </div>
      );
    }
    const isFiltered = filter.search || filter.status || filter.order_by;

    if (proposalList.length === 0) {
      // If filters are applied and no data is found
      if (isFiltered) {
        return (
          <div className="text-center d-flex flex-column justify-content-center align-items-center" style={{ minHeight: '600px' }}>
            <h2 className='text-secondary'>No Data Found</h2>
            <p className="mb-4">No proposals match the current filters.</p>

          </div>
        );
      }

      // If no filters applied and no proposals exist
      return (
        <div className="text-center d-flex flex-column justify-content-center align-items-center" style={{ minHeight: '600px' }}>
          <h2 className='text-secondary'>Create Your First Proposal</h2>
          <p className="mb-4">Click on the below button and you are ready to create</p>
          <button onClick={() => handleProposalInfo()}
            className="align-items-center btn btn-outline-custom active btn-sm d-inline-flex rounded-3 fs-6 px-4 py-2">
            <iconify-icon icon="lucide:plus" class="fs-4 me-1 my-1"></iconify-icon>
            Create Proposal
          </button>
        </div>
      );
    }

    return filteredProposals.map((proposal) => (
      <div key={proposal.id} className="col-6 col-md-4 col-xl-2 col-xxl-2 mb-4">
        <div className="doc-card">
          <span className={`doc-badge ${getStatusClass(proposal.status)}`}>{getStatusText(proposal.status)}</span>
          <div className="dropdown doc-actions">
            <a className="no-caret" href="#" role="button" id="docActions" data-bs-toggle="dropdown" aria-expanded="false">
              <iconify-icon icon="pepicons-pencil:dots-y" class="text-secondary fs-5"></iconify-icon>
            </a>
            <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="docActions">
              <li><a className={`dropdown-item ${proposal.status == 1 ? 'disabled' : ''}`} href="" onClick={(e) => { e.preventDefault(); handleEditProposal(proposal) }}><span class="d-flex align-items-center gap-2"><iconify-icon icon="lucide:edit" class="fs-14 yellow"></iconify-icon> Edit</span></a></li>
              <li><a className="dropdown-item" href="#" onClick={() => confirmBeforeDelete(proposal.id)}><span class="d-flex align-items-center gap-2"><iconify-icon icon="lucide:trash" class="fs-14 yellow"></iconify-icon> Delete</span></a></li>
              <li><a className={`dropdown-item ${proposal.status == 0 || proposal.status == 3 ? 'disabled' : ''}`} href="#" onClick={() => handleButtonClick(proposal)}><span class="d-flex align-items-center gap-2"><iconify-icon icon="fluent:mail-24-regular" class="fs-16 yellow"></iconify-icon> Send to Email</span></a></li>

            </ul>
          </div>
          <div className="doc-icon">
            <iconify-icon icon={getIconForType(proposal.file_type)}></iconify-icon>
          </div>
          <div className="doc-info">
            <h2 className="text-truncate">{proposal.title}</h2>
            <p className="doc-date d-inline-flex gap-1">
              <iconify-icon icon="pixel:calender-solid" class="fs-12 yellow" />
              {moment(proposal.created_at).format("MM-DD-YYYY")}
            </p>
            <div className="doc-link">
              <button onClick={() => window.open(proposal?.signed_url, "_blank")} class="d-flex align-items-center justify-content-center mx-auto">
                <iconify-icon icon="lsicon:right-outline" />
              </button>


            </div>
          </div>
        </div>
      </div>
    ));
  };

  const getIconForType = (type) => {
    if (type?.toLowerCase() === 'pdf') {
      return 'material-icon-theme:pdf';
    } else {
      return 'material-icon-theme:pdf'; // Default icon if the type isn't PDF
    }
  };

  const handleStatusChange = (e) => {
    const newStatus = e.target.value;
    // Update the filter state directly with the new status
    setFilter((prevFilter) => {
      const updatedFilter = { ...prevFilter, status: newStatus };
      // Call the function immediately after updating the state
      getProposalList(1, updatedFilter.search, newStatus, updatedFilter.order_by);
      return updatedFilter;
    });
  };

  return (
    <>
      <div className="pb-5">
        {alert}
        <div className="container-fluid">
          <div className="row">
            <div className="card custom-card px-0 rounded-4">
              {(proposalList.length !== 0 || filter.search || filter.status || filter.order_by) && (
                <div className="card-header d-flex justify-content-between align-items-center bg-white rounded-4 border-0 p-4 flex-wrap gap-2">
                  <h5 className="mb-0">My Documents</h5>
                  <div className="d-flex align-items-center gap-3 flex-wrap">
                    <div className="d-flex align-items-center">
                      <div className="w-100 position-relative search-box">
                        <input
                          value={filter.search}
                          onChange={(e) => setFilter({ ...filter, search: e.target.value })}
                          type="text"
                          onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                              applyFilter(); // Call your search function here
                            }
                          }}
                          className="form-control pe-5 bg-light"
                          placeholder="Search"
                          aria-label="Search"

                        />
                        <iconify-icon
                          onClick={applyFilter}
                          icon="uil:search"
                          class="end-0 fs-6 position-absolute top-50 translate-middle"
                        ></iconify-icon>
                      </div>
                      <iconify-icon
                        icon="oi:reload"
                        onClick={clearFilter}
                        class="fs-14 ms-2 pointer reset-btn"
                      ></iconify-icon>
                    </div>

                    <div className="dropdown">
                      <a
                        className="btn no-caret filter-btn dropdown-toggle lh-lg border px-4 d-inline-flex align-items-center gap-1"
                        href="#"
                        role="button"
                        id="filterOptions"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        <iconify-icon icon="mi:filter" class="fs-18 yellow"></iconify-icon>
                        Filters
                      </a>

                      <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="filterOptions">
                        <li>
                          <a
                            className="dropdown-item"
                            href="#"
                            onClick={() => setFilter((prev) => ({ ...prev, order_by: 'created_at' }))}
                          >
                            Sort By Date
                          </a>
                        </li>
                        <li>
                          <a
                            className="dropdown-item"
                            href="#"
                            onClick={() => setFilter((prev) => ({ ...prev, order_by: 'title' }))}
                          >
                            Sort By Name
                          </a>
                        </li>
                      </ul>
                    </div>

                    <select
                      className="form-select w-auto fs-14"
                      onChange={handleStatusChange}
                      value={filter.status}
                    >
                      <option value="">All</option>
                      <option value="1">Approved</option>
                      <option value="2">Rejected</option>
                      <option value="0">Pending</option>
                      <option value="3">Drafts</option>
                    </select>

                    <button
                      // onClick={() => navigate(appRoutes.pdfEditorPageRoute)}
                      onClick={() => handleProposalInfo()}
                      className="align-items-center btn btn-outline-custom active btn-sm d-inline-flex px-3 py-2 rounded-3 flex-shrink-0 fs-14"
                    >
                      <iconify-icon icon="lucide:plus" class="fs-4 me-1"></iconify-icon>
                      Create Proposal
                    </button>
                  </div>
                </div>
              )}


              <div className="card-body px-4">
                <div style={{ minHeight: '500px' }}>
                  <div className="row">
                    {renderProposalCards()}
                  </div>
                </div>
                <Pagination
                  className="pagination-bar"
                  currentPage={paginationData.page}
                  totalCount={paginationData.totalCount}
                  pageSize={paginationData.perpage}
                  onPageChange={(page) => getProposalList(page, filter.search, filter.status, filter.order_by)}
                />
              </div>

            </div>
          </div>
        </div>
      </div>
      {showModal && (
        <SendPdfToEmail
          showPopup={showModal}
          setShowModal={setShowModal}
          proposalList={selectedProposal} // <-- pass it here
          users={users}
        />
      )}
      {proposalInfoModal && (
        <ProposalInfo
          proposalInfoModal={proposalInfoModal}
          setShowProposalInfoModal={setShowProposalInfoModal}
        />
      )}
      <Footer />
    </>
  );
};

export default ListProposal;
